import I18n from "i18n-js"
import translations from "../../../config/locales/translations_js.json"
I18n.translations = translations
I18n.defaultLocale = window.defaultLocale;
I18n.locale = window.locale;
window.I18n = I18n
export default I18n